import React from 'react';

import { Link } from 'react-router';
import { FormattedDate } from 'react-intl';

import { Card } from 'material-ui/Card';
import { ListItem } from 'material-ui/List';
import ResourceIcon from 'material-ui/svg-icons/av/library-books';
import { statusColours } from '../../constants/ColourConstants';

import PrivateIcon from 'material-ui/svg-icons/action/lock';
import SkillIcon from 'material-ui/svg-icons/social/public';
import CPDIcon from 'material-ui/svg-icons/toggle/star';
import DoneIcon from 'material-ui/svg-icons/action/done';
import DoneAllIcon from 'material-ui/svg-icons/action/done-all';
import SpotIcon from 'material-ui/svg-icons/image/lens';


import { DateStyles } from '../../constants/CentricConstants';


const style = {
    menu: {
        marginRight: 0,
        marginBottom: 0,
        float: 'left',
        position: 'relative',
        zIndex: 0,
    },
    menuItem: {
        color: '#CC0000',
    },
    iconButton: {
        marginRight: 0,
    },
    listItem: {
        padding: '2px',
    },
    icon: {
        height: '32px',
        width: '32px',
        margin: '0',
        padding: '0',
    }
};


const MyResourceCard = (props) => {

    const infoLink = `/dashboard/module/${props.id}`;

    const listItemProps = {
        key: props.id,
        style: style.listItem,
        secondaryTextLines: 2,
    };

    let description = [];

    description.push(`${props.code} - `);

    const released = new Date(props.validFrom);
    description.push(<FormattedDate {...DateStyles.long} value={released} key="date" />);

    listItemProps.primaryText = (
        <Link to={infoLink} className="primaryText">
            {props.name}
        </Link>
    );

    let iconColor = statusColours.default;

    let iconGroup = [];
    if (props.visibility === 'private') {
        iconGroup.push(<PrivateIcon className="icon-small" key="visibility" />);
    }

    if (props.skillId) {
        iconGroup.push(<SkillIcon className="icon-small" key="skill" />);
    }

    if (Number(props.cpdCredits)) {
        iconGroup.push(<CPDIcon className="icon-small" key="cpd" />);
    }

    if (props.isAssigned) {
        if (props.isMandatory) {
            iconGroup.push(<SpotIcon className="icon-small" color={statusColours.mandatory} key="mandatory"/>);
        } else {
            iconGroup.push(<SpotIcon className="icon-small" color={statusColours.optional} key="optional"/>);
        }
    }

    listItemProps.secondaryText = (
        <Link to={infoLink} className="secondaryText">
            {description}<br />
            {iconGroup}
        </Link>
    );


    switch (props.enrolmentStatus) {

        case 'enrolled':
            iconColor = statusColours.enrolled;
            iconGroup.push(<DoneIcon className="icon-small" key="enrolled" />);
            break;

        case 'completed':
            iconColor = statusColours.completed;
            iconGroup.push(<DoneAllIcon className="icon-small" color={statusColours.primary} key="done" />);
            break;

        case 'cancelled':
            iconColor = statusColours.cancelled;
            break;

        default:
            break;
    }

    let avatarIcon = (<ResourceIcon style={style.icon} color={iconColor}/>);

    return (
        <Card className="cent-card cent-card-list-item" key={props.id}>
            <ListItem {...listItemProps}
                leftAvatar={<Link to={infoLink}>{avatarIcon}</Link>}
            />
        </Card>
    );
};

export default MyResourceCard;
